import storage from "@/services/storage";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class S3BucketMixins extends Vue {
  filepath: string | null = null;

  async s3BucketUpload(name: string, file: any) {
    try {
      if (file) {
        await this.setFile(name, file);
        await this.getFile(name);
      }
    } catch (e) {}
  }

  async setFile(key: string, file: any) {
    await storage.save(key, file)
      .then(() => {
        this.filepath = key;
      })
      .catch((err: any) => (this.filepath = ""));
  }

  async getFile(key: string): Promise<void> {
    await storage.get(key)
      .then((result: any) => {
        return (this.filepath = result);
      })
      .catch((err: any) => (this.filepath = ""));
  }

  async getFilePath(key: string) {
    return await storage.get(key)
      .then((result: any) => result)
      .catch((err: any) => {
        throw err;
      });
  }

  async removeFile(key: string) {
    await storage.delete(key)
      .then((result: any) => result)
      .catch((err: any) => {
        throw err;
      });
  }
}
